<glxy-sticky-footer>
  <button mat-flat-button color="primary" (click)="submitClick.emit()" [disabled]="disabled()">
    {{ submitOverride() || 'AI_ASSISTANT.SHARED.SAVE' | translate }}
  </button>
  @if (!hideCancel() && cancelLink()) {
    <a mat-stroked-button [routerLink]="[cancelLink()]">
      {{ cancelOverride() || 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
    </a>
  } @else if (!hideCancel()) {
    <button mat-stroked-button (click)="cancelClick.emit()">
      {{ cancelOverride() || 'AI_ASSISTANT.SHARED.CANCEL' | translate }}
    </button>
  }
  <span glxyStickyFooterSecondary>
    @if (showUnsavedChangesIndicator()) {
      <span class="unsaved-changes-text">
        {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
      </span>
    }
    @if (showCallButton()) {
      @if (callState() === 'idle' || callState() === 'disconnected' || callState() === 'error') {
        <button
          mat-flat-button
          color="primary"
          [disabled]="callDisabled()"
          [glxyTooltip]="callDisabled() ? callDisabledTooltip() : ''"
          (click)="callClick.emit()"
        >
          <mat-icon>call</mat-icon>
          {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CALL' | translate }}
        </button>
      } @else if (callState() === 'connecting') {
        <button mat-flat-button color="primary" disabled>
          {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CONNECTING' | translate }}
        </button>
      } @else if (callState() === 'connected') {
        <button mat-flat-button color="warn" (click)="endCallClick.emit()">
          <mat-icon>call_end</mat-icon>
          {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.END_CALL' | translate }}
        </button>
      }
    }
  </span>
</glxy-sticky-footer>
